<template>
  <div>
    <div class="flex-right">
      <Button type="primary" @click="save">保存</Button>
    </div>
    <Card class="one-card">
      <h2 slot="title">Household</h2>
      <i-form :model="data" label-position="top">
        <Row :gutter="16">
          <i-col span="6">
            <FormItem label="Parents' Marital Status">
              <i-input v-model="data.parents_marital_status"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="With Whom（if divorce）">
              <i-input v-model="data.with_whom"></i-input>
            </FormItem>
          </i-col>
        </Row>
      </i-form>
    </Card>
    <Card class="one-card">
      <h2 slot="title">Father</h2>
      <i-form :model="data.father_info" label-position="top">
        <Row :gutter="16">
          <i-col span="24">
            <FormItem label="Name">
              <i-input v-model="data.father_info.name"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Preferred Email">
              <i-input v-model="data.father_info.preferred_email"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Preferred Phone">
              <i-input v-model="data.father_info.preferred_phone"></i-input>
            </FormItem>
          </i-col>
          <i-col span="24">
            <FormItem label="Address">
              <i-input v-model="data.father_info.address"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Occupation">
              <i-input v-model="data.father_info.occupation"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Employment Status">
              <i-input v-model="data.father_info.employment_status"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Position/Title">
              <i-input v-model="data.father_info.position"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Name of Employer">
              <i-input v-model="data.father_info.name_of_employer"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Education Level">
              <i-input v-model="data.father_info.education_level"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Indicate the number of colleges">
              <i-input
                v-model="data.father_info.indicate_the_number_of_colleges"
              ></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Name of College">
              <i-input v-model="data.father_info.name_of_college"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Degree Received">
              <i-input v-model="data.father_info.degree_received"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Address of College">
              <i-input v-model="data.father_info.address_of_college"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Year Received">
              <i-input v-model="data.father_info.year_received"></i-input>
            </FormItem>
          </i-col>
        </Row>
      </i-form>
    </Card>
    <Card class="one-card">
      <h2 slot="title">Mother</h2>
      <i-form :model="data" label-position="top">
        <Row :gutter="16">
          <i-col span="24">
            <FormItem label="Name">
              <i-input v-model="data.mother_info.name"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Preferred Email">
              <i-input v-model="data.mother_info.preferred_email"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Preferred Phone">
              <i-input v-model="data.mother_info.preferred_phone"></i-input>
            </FormItem>
          </i-col>
          <i-col span="24">
            <FormItem label="Address">
              <i-input v-model="data.mother_info.address"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Occupation">
              <i-input v-model="data.mother_info.occupation"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Employment Status">
              <i-input v-model="data.mother_info.employment_status"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Position/Title">
              <i-input v-model="data.mother_info.position"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Name of Employer">
              <i-input v-model="data.mother_info.name_of_employer"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Education Level">
              <i-input v-model="data.mother_info.education_level"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Indicate the number of colleges">
              <i-input
                v-model="data.mother_info.indicate_the_number_of_colleges"
              ></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Name of College">
              <i-input v-model="data.mother_info.name_of_college"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Degree Received">
              <i-input v-model="data.mother_info.degree_received"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Address of College">
              <i-input v-model="data.mother_info.address_of_college"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Year Received">
              <i-input v-model="data.mother_info.year_received"></i-input>
            </FormItem>
          </i-col>
        </Row>
      </i-form>
    </Card>

    <Card class="one-card">
      <h2 slot="title">Siblings</h2>
      <i-form :model="data" label-position="top">
        <Row :gutter="16">
          <template v-for="item in data.siblings">
            <i-col span="6" :key="item.name">
              <FormItem label="Name">
                <i-input v-model="item.name"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6" :key="item.sibship">
              <FormItem label="Sibship">
                <i-input v-model="item.sibship"></i-input>
              </FormItem>
            </i-col>
          </template>
          <i-col span="24">
            <Button type="dashed" @click="add_one_siblings">添加一行</Button>
            <Button
              type="text"
              style="margin-left: 10px"
              @click="delelt_last_siblings"
              >删除最后一行</Button
            >
          </i-col>
        </Row>
      </i-form>
    </Card>

    <div class="flex-right">
      <Button type="primary" @click="save">保存</Button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    async getData() {
      if (!this.$store.getters.selectedStudent._id) {
        return;
      }

      let res = await this.api({
        url: "/student/getFamilyInfoById",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
        },
      });

      this.data = res;
    },

    add_one_siblings() {
      this.data.siblings.push({
        name: "",
        sibship: "",
      });
    },

    delelt_last_siblings() {
      this.data.siblings.pop();
    },

    async save() {
      await this.api({
        url: "/student/saveFamilyInfo",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          student_id: this.$store.getters.selectedStudent._id,
          ...this.data,
          father_info: JSON.stringify(this.data.father_info),
          mother_info: JSON.stringify(this.data.mother_info),
          siblings: JSON.stringify(this.data.siblings),
        },
      });

      this.$Message.success("更新成功");
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    "$store.getters.selectedStudent": function () {
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
h2 {
  margin: 0;
  font-size: 24px;
  font-weight: bolder;
}
.one-card {
  margin-bottom: 20px;
}
</style>